var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4998 17.3327C6.42317 17.3327 0.666504 11.576 0.666504 4.49935C0.666504 2.38518 2.3865 0.666016 4.49984 0.666016C4.7165 0.666016 4.93067 0.684349 5.13817 0.720182C5.34067 0.752682 5.54484 0.804349 5.74234 0.872682C6.014 0.966849 6.21734 1.19435 6.2815 1.47435L7.42317 6.44435C7.48567 6.71768 7.4065 7.00435 7.21234 7.20768C7.09817 7.32602 7.09567 7.32852 6.06234 7.86935C6.899 9.68102 8.35317 11.1302 10.129 11.9385C10.6698 10.9043 10.6732 10.901 10.7915 10.7877C10.9957 10.5927 11.2832 10.5168 11.5557 10.5768L16.5257 11.7177C16.8048 11.7818 17.0323 11.9852 17.1265 12.256C17.1948 12.4527 17.2457 12.656 17.2798 12.8652C17.3148 13.071 17.3332 13.2843 17.3332 13.4993C17.3332 15.6135 15.614 17.3327 13.4998 17.3327Z",
    fill: "#00A0F3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.42774260.svg";
export { ForwardRef as ReactComponent };